import React from 'react';
import { MapFeature } from '../types';
import {useFarm} from '../services/farmContext';
import { pointStyle,pointColor } from '../services/placeModel';
export default function PlaceIcon({ place, color, className = 'h-6 w-6' }: { place: Partial<MapFeature>; color?:string; className?: string }) {
  const style = pointStyle(place);
  const {activeFarm}=useFarm();
  return <svg aria-hidden="true" className={className} viewBox="0 0 24 24" fill="none" stroke={color||pointColor(place,activeFarm?.poi_colors)} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={style.path} /></svg>;
}
